<template>
  <div class="q-pa-lg text-body1">
    <div class="text-weight-bold q-mb-sm">
      Import Process Initiated
      <q-icon name="fa fa-headset" size="2rem" class="on-right" />
    </div>
    <app-user v-slot="{ isCustomer, isClient }">
      <div v-if="isCustomer">
        <p>
          The client has initiated the import process.
          You will be notified by email when the posts are available for your review.
        </p>
      </div>
      <div v-else-if="isClient">
        <p>
          A member of our support team will contact you via email
          to help you complete the import process.
        </p>
        <p>If you do not need support, you can import your posts by clicking below.</p>
        <import-posts-btn :account="account" color="primary" label="Import Posts" rounded />
      </div>
    </app-user>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import AppUser from '@/auth/AppUser.vue';
import { Account } from '@/social/types';
import ImportPostsBtn from '@/social/post/import/with-account/ImportPostsBtn.vue';

export default defineComponent({
  components: { AppUser, ImportPostsBtn },
  props: {
    account: {
      type: Object as () => Account,
      required: true,
    },
  },
});
</script>
